module.exports = __webpack_public_path__ + "static/media/Illus-SupplyChain@2x.fd521bfe.png";